import React from 'react';
import { Typography as MuiTypography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getActivityStatus } from 'lib/utils/getActivityStatus';

type LastActivityBadgeProps = {
  isSelfRegistered: boolean;
  lastActivity: string | null;
};

const LastActivityBadge = ({
  lastActivity,
  isSelfRegistered,
}: LastActivityBadgeProps) => {
  const { t } = useTranslation();
  const theme = useTheme()

  const chipInfo = getActivityStatus(lastActivity, isSelfRegistered, theme);

  return (
    <MuiTypography
      variant="subtitle1"
      style={{
        color: chipInfo.color,
      }}
    >
      {t(chipInfo.text)}
    </MuiTypography>
  );
};

export default LastActivityBadge;
